import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionTriageNextV3Response } from '../getCollectionTriageNextV3/get-collection-triage-next-v3-response';
import { getCollectionTriageNextV3ResponseSchema } from '../getCollectionTriageNextV3/get-collection-triage-next-v3-response';
import type { IGetCollectionTriageClipV3Request } from './get-collection-triage-clip-v3-request';

export async function getCollectionTriageClipV3Api({
  collectionId,
  clipId,
}: IGetCollectionTriageClipV3Request): Promise<
  IValidatedResponse<IGetCollectionTriageNextV3Response>
> {
  return getRequest<IGetCollectionTriageNextV3Response>({
    path: `/sys/collections/${collectionId}/triage/clip/v3?clipId=${clipId}`,
    schema: getCollectionTriageNextV3ResponseSchema,
  });
}
